import { toast } from 'sonner'
import * as XLSX from 'xlsx'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'

export interface ExportColumn {
  key: string
  label: string
}

export const exportToCSV = (
  data: any[],
  filename: string,
  columns: ExportColumn[],
) => {
  if (data.length === 0) {
    toast.error('Tidak ada data untuk diekspor.')
    return
  }

  const headers = columns.map((c) => c.label)
  const escape = (val: any) => `"${String(val || '').replace(/"/g, '""')}"`

  const rows = data.map((item) =>
    columns.map((c) => escape(item[c.key])).join(','),
  )

  const csv = [headers.map(escape).join(','), ...rows].join('\n')
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.download = `${filename}-${new Date().toISOString().slice(0, 10)}.csv`
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)

  toast.success(`${data.length} baris diekspor ke CSV.`)
}

export const exportToExcel = (
  data: any[],
  filename: string,
  columns: ExportColumn[],
) => {
  if (data.length === 0) {
    toast.error('Tidak ada data untuk diekspor.')
    return
  }

  const formattedData = data.map((item) => {
    const row: any = {}
    columns.forEach((col) => {
      row[col.label] = item[col.key]
    })
    return row
  })

  const worksheet = XLSX.utils.json_to_sheet(formattedData)
  const workbook = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Data')

  XLSX.writeFile(
    workbook,
    `${filename}-${new Date().toISOString().slice(0, 10)}.xlsx`,
  )

  toast.success(`${data.length} baris diekspor ke Excel.`)
}

export const exportToPDF = (
  data: any[],
  filename: string,
  columns: ExportColumn[],
  title: string,
) => {
  if (data.length === 0) {
    toast.error('Tidak ada data untuk diekspor.')
    return
  }

  const doc = new jsPDF()

  // DENS CAKRA branding masthead on every exported PDF.
  doc.setFontSize(16)
  doc.setTextColor(41, 128, 185)
  doc.text('DENS CAKRA', 14, 15)
  doc.setFontSize(8)
  doc.setTextColor(120, 120, 120)
  doc.text('Dashboard Evaluasi Nasional dan Situational Awareness', 14, 20)

  doc.setFontSize(13)
  doc.setTextColor(20, 20, 20)
  doc.text(title, 14, 30)
  doc.setFontSize(9)
  doc.setTextColor(120, 120, 120)
  doc.text(`Tanggal Ekspor: ${new Date().toLocaleString('id-ID')}`, 14, 36)

  const tableColumn = columns.map((c) => c.label)
  const tableRows = data.map((item) =>
    columns.map((c) => String(item[c.key] || '')),
  )

  autoTable(doc, {
    head: [tableColumn],
    body: tableRows,
    startY: 42,
    theme: 'grid',
    styles: {
      fontSize: 8,
      font: 'helvetica',
    },
    headStyles: {
      fillColor: [41, 128, 185],
      textColor: 255,
    },
  })

  doc.save(`${filename}-${new Date().toISOString().slice(0, 10)}.pdf`)

  toast.success(`${data.length} baris diekspor ke PDF.`)
}
